import { IFilterPanel, IDealFilters, IDealFilterOptions } from '../types';
import { NSSelectOption } from '@northspyre-inc/ui';

export const FILTER_PANELS: IFilterPanel[] = [
    {
        id: 'market',
        label: 'Market',
        type: 'pick-list',
        filterKey: 'markets',
        optionsKey: 'market',
        chipLabel: 'Market',
    },
    {
        id: 'state',
        label: 'State',
        type: 'pick-list',
        filterKey: 'states',
        optionsKey: 'state',
        chipLabel: 'State',
    },
    {
        id: 'assetType',
        label: 'Asset type',
        type: 'pick-list',
        filterKey: 'assetTypes',
        optionsKey: 'assetType',
        chipLabel: 'Asset Type',
    },
    {
        id: 'constructionType',
        label: 'Construction type',
        type: 'pick-list',
        filterKey: 'constructionTypes',
        optionsKey: 'constructionType',
        chipLabel: 'Construction Type',
    },
    {
        id: 'dealOwner',
        label: 'Deal owner',
        type: 'pick-list',
        filterKey: 'dealOwners',
        optionsKey: 'dealOwner',
        chipLabel: 'Deal Owner',
    },
    {
        id: 'developmentManager',
        label: 'Development manager',
        type: 'pick-list',
        filterKey: 'developmentManagers',
        optionsKey: 'developmentManager',
        chipLabel: 'Development Manager',
    },
    {
        id: 'dateCreated',
        label: 'Date created',
        type: 'date-range',
        afterKey: 'createdAfter',
        beforeKey: 'createdBefore',
        afterChipLabel: 'Created After',
        beforeChipLabel: 'Created Before',
    },
    {
        id: 'dateUpdated',
        label: 'Date updated',
        type: 'date-range',
        afterKey: 'updatedAfter',
        beforeKey: 'updatedBefore',
        afterChipLabel: 'Updated After',
        beforeChipLabel: 'Updated Before',
    },
    {
        id: 'acquisitionPrice',
        label: 'Acquisition price',
        type: 'number-range',
        minKey: 'acquisitionPriceMin',
        maxKey: 'acquisitionPriceMax',
        minChipLabel: 'Acquisition Price Min',
        maxChipLabel: 'Acquisition Price Max',
    },
    {
        id: 'totalDevelopmentBudget',
        label: 'Total development budget',
        type: 'number-range',
        minKey: 'totalDevelopmentCostMin',
        maxKey: 'totalDevelopmentCostMax',
        minChipLabel: 'Total Dev Cost Min',
        maxChipLabel: 'Total Dev Cost Max',
    },
];

export const EMPTY_FILTER_OPTIONS: IDealFilterOptions = {
    market: [],
    state: [],
    assetType: [],
    constructionType: [],
    dealOwner: [],
    developmentManager: [],
};

export const EMPTY_DEAL_FILTERS: IDealFilters = {
    markets: [],
    states: [],
    assetTypes: [],
    constructionTypes: [],
    dealOwners: [],
    developmentManagers: [],
    createdAfter: undefined,
    createdBefore: undefined,
    updatedAfter: undefined,
    updatedBefore: undefined,
    acquisitionPriceMin: undefined,
    acquisitionPriceMax: undefined,
    totalDevelopmentCostMin: undefined,
    totalDevelopmentCostMax: undefined,
};

export const DATE_OPERATOR_OPTIONS: NSSelectOption[] = [
    { label: 'After', value: 'After' },
    { label: 'Before', value: 'Before' },
];

export const NUMBER_OPERATOR_OPTIONS: NSSelectOption[] = [
    { label: '>', value: '>' },
    { label: '<', value: '<' },
];